<template>
  <v-card :color="$vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-2'">
    <v-row class="no-gutters align-center">
      <v-col cols="12" sm="6" md="3" lg="4" :sm="$canRoute('inactive-accounts') !== 1 ? 12 : 6"
        :md="$canRoute('inactive-accounts') !== 1 ? 5 : 3" :lg="$canRoute('inactive-accounts') !== 1 ? 6 : 4">
        <v-text-field v-model="search" prepend-icon="mdi-magnify" label="Search " single-line solo
          hide-details></v-text-field>
      </v-col>
      <v-col cols="12" sm="6" md="2" lg="4">
        <v-select solo :items="slots1" append-icon="mdi-chevron-down" label="Select" class="custom-select"></v-select>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="2">
        <ul>
          <li>
            <span class="text-red">Total Inactive:</span>
            <span>254</span>
          </li>
        </ul>
      </v-col>
      <v-col cols="12" sm="6" md="2" lg="2" v-if="$canRoute('inactive-accounts') === 1">
        <v-btn tile elevation="0" to="/create-new-user-account"
          class="mt-8 text-capitalize btn-account mb-0 mx-0 px-2 font-weight-bold" color="greenMain">
          Send Email to All
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="pa-0 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
          <v-sheet class="transactionTable depositTabTable registerUserTable"
            :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
            <v-data-table :headers="headers" :items-per-page="7" :items="Transaction">

              <template v-slot:item.email="{ item }">
                <v-tooltip top color="#000">
                  <template v-slot:activator="{ on }">
                    <v-btn plain title x-small v-on="on" @click="copyText">
                      {{ item.email }}
                      <v-icon x-small class="ml-1">mdi-content-copy</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ item.email }}</span>
                </v-tooltip>
              </template>

              <template v-slot:item.ActionView="{ item }">
                <v-btn small :to="item.ActionView" elevation="0" color="#039de9" class="text-capitalize">
                  <span class="black--text text-capitalize">Send Email</span>
                </v-btn>
              </template>

              <template v-slot:item.details="{ item }">
                <router-link class="links text-decoration-none" to="/registered-user-details">
                  <v-icon color="#039de9" small>
                    {{ item.details }}
                  </v-icon>
                </router-link>
              </template>

            </v-data-table>
          </v-sheet>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
export default {
  data() {
    return {
      slots1: ["Inactive Days: High-Low", "Inactive Days: Low-High"],
      search: "",
      headers: [
        { text: "Name", value: "nameLink" },
        { text: "Account No.", value: "AccountNoLink" },
        { text: "Last Active", value: "LastActive" },
        { text: "Email", value: "email" },
        { text: "Email Send", value: "EmailSend" },
      ],

      Transaction: [
        {
          AccountNoLink: "MT43359050-8",
          nameLink: "Sheldon (5008)",
          LastActive: "2019-08-11 12:17:06",
          email: "Sheldon.nc@gmail.com",
          EmailSend: 3,
          ActionView: "/news",
          details: "mdi-eye-outline",
        },
        {
          AccountNoLink: "MT43359050-8",
          nameLink: "jonh (5008)",
          LastActive: "2019-08-11 12:17:06",
          email: "jonh.nc@gmail.com",
          EmailSend: 3,
          ActionView: "/news",
          details: "mdi-eye-outline",
        },
      ],
    };
  },

  methods: {
    copyText() {
      const textToCopy = "nc@gmail.com";
      navigator.clipboard.writeText(textToCopy);
    },
  },

  created() {
    if (this.$canRoute('inactive-accounts') === 1) {
      this.headers.push({ text: "Action", value: "ActionView" });
      this.headers.push({ text: "Details", value: "details" });
    }
  }

};
</script>
